/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Notfound_DescInputs */

const en_directory_notfound_desc = /** @type {(inputs: Directory_Notfound_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tool you are looking for does not exist or was removed.`)
};

const zh_directory_notfound_desc = /** @type {(inputs: Directory_Notfound_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你要找的工具不存在或已被移除。`)
};

/**
* | output |
* | --- |
* | "The tool you are looking for does not exist or was removed." |
*
* @param {Directory_Notfound_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_notfound_desc = /** @type {((inputs?: Directory_Notfound_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Notfound_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_notfound_desc(inputs)
	return zh_directory_notfound_desc(inputs)
});
export { directory_notfound_desc as "directory.notfound.desc" }